import React, {FC, useState} from 'react'
import {useCognitoAuth} from '../../../../app/modules/auth'
import {toAbsoluteUrl} from '@/shared/utils'
import {HeaderUserMenu} from '@/ui/components/layout/header-menus/HeaderUserMenu'

const ProfilePhoto: FC = () => {
  const {currentUser} = useCognitoAuth()
  const [imageError, setImageError] = useState(false)

  // Get profile photo URL - use Google profile picture if available, otherwise default avatar
  const profilePhotoUrl =
    currentUser?.picture && !imageError
      ? currentUser.picture
      : toAbsoluteUrl('/media/avatars/blank.png')

  const handleImageError = () => {
    setImageError(true)
  }

  return (
    <div className='profile-photo'>
      {/* Profile Photo with Menu Trigger */}
      <div
        className='d-flex align-items-center'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
        data-kt-menu-flip='top-end'
      >
        <div className='symbol symbol-40px symbol-circle'>
          <img
            src={profilePhotoUrl}
            alt='Profile'
            className='profile-photo__image'
            onError={handleImageError}
          />
        </div>
      </div>

      {/* User Menu Dropdown - will be triggered by data-kt-menu-trigger */}
      <HeaderUserMenu />
    </div>
  )
}

export {ProfilePhoto}
